var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('section',[_c('img',{attrs:{"src":_vm.data.image}}),_c('p',[_vm._v(_vm._s(_vm.data.name))]),_c('span',[_vm._v(_vm._s(_vm.data.subtitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }